import React, { useState, useEffect } from 'react';
import GoalTable from './GoalTable0';
import { getSocietes } from '../../flux/actions/societeActions';
import { clearGoals, getGoalsByProject } from '../../flux/actions/goalActions';
import { getGoal_societe_defaults } from '../../flux/actions/goalsocietedefaultActions';
import { getBudgets } from '../../flux/actions/budgetActions';
import { getUsersWhoWorksAt } from '../../flux/actions/userActions';
import { Container, Row, Col, Label } from 'reactstrap';

import { connect } from 'react-redux';
import { IGoalContainer0, IGoalReduxProps0 } from '../../types/interfaces';
import Select from 'react-select';
import LoadingPage from '../../pages/loading';
import { constants } from '../../types/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUsers, faDesktop, faBullseye, faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import Loading from '../Loading';

const GoalContainerComponent = ({
  getGoalsByProject,
  clearGoals,
  goal,
  getGoal_societe_defaults,
  goal_societe_default,
  getBudgets,
  budget,
  getSocietes,
  societe,
  auth
 }: IGoalContainer0) => {

  const { goals, loading: loadingG } = goal;
  const { goal_societe_defaults, loading: loadingGSD } = goal_societe_default;
  const { budgets, loading: loadingB } = budget;
  const { societes, loading: loadingS } = societe;
  const [tableData, setTableData] = useState<any[]>([]);
  const societeOptions = [{value: {id: "ALL", LIBELE: "Tous les projets"}, label: "Tous les projets"}, ...societes.map(e => ({value: e, label: e.LIBELE}))];
  const [societeValue, setSocieteValue] = useState<any>('');
  const today = new Date();
  const [yearValue, setYearValue] = useState<any>(today.getFullYear());
  const [users, setUsers] = useState<any[]>([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  
  useEffect(() => {
    clearGoals()
    if(societeValue)
      getGoalsByProject(societeValue?.id);
  }, [getGoalsByProject, societeValue]);
  
  useEffect(() => {
    getGoal_societe_defaults();
  }, [getGoal_societe_defaults]);
  
  useEffect(() => {
    getBudgets();
  }, [getBudgets]);
  
  useEffect(() => {
    if(societeValue){
      setUsersLoading(true)
      getUsersWhoWorksAt(societeValue.id).then(e => setUsers(e))
      .catch(e => setUsers([]))
      .finally(() => setUsersLoading(false))
    }
    else
      setUsers([])
  }, [societeValue]);

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  useEffect(() => {
    if(!societeValue && societes && societes.length){
      if(auth && auth.user){
        for(let so of societes)
          if(so.id == auth.user.last_societe){
            setSocieteValue(so);
            break
          }
      }
    }
  }, [societes]);

  useEffect(() => console.log(societes, users), [societes, users])

  const getGoalsFromDateProjUser = (userId: number, societeId: any, month: number, year: number) => {
    let res: any = goals.find(e => e.comId === userId && e.societeId === societeId && e.month === month && e.year === year);
    if(!res)
      res = goal_societe_defaults.find(e => e.societeId === societeId && e.month === month && e.year === year)
    
    return res
  }

  useEffect(() => {
    setTableData([
      {
        name: "Objectif Budget",
        isBudget: true,
        ...constants.DP_MONTHS.map((e, i) => ({
          ...(societeValue?.id === "ALL" ? {
            // goalV: budgets.filter(e => e.month === (i + 1) && e.year === yearValue && societes.map(e => e.id).includes(e.societeId)).reduce((e, t) => e + t.goalV || 0, 0),
            goalV: societes.reduce((e, t) => e + (budgets.find(e => e.month === (i + 1) && e.year === yearValue && t.id === e.societeId)?.goalV || 0), 0),
            goalE: societes.reduce((e, t) => e + (budgets.find(e => e.month === (i + 1) && e.year === yearValue && t.id === e.societeId)?.goalE || 0), 0),
            societesWithNoBudgets: societes.filter(n => !budgets.find(e => e.month === (i + 1) && e.year === yearValue && n.id === e.societeId))
          } : budgets.find(e => e.month === (i + 1) && e.year === yearValue && e.societeId === societeValue?.id)),
          month: i + 1,
          year: yearValue,
        })).reduce((e, t, i) => ({...e, [String(t.month)]: t}), {})
      },
      {
        name: "Objectif Commercial",
        showHideUsers: societeValue?.id !== "ALL",
        ...constants.DP_MONTHS.map((e, i) => ({
          ...(societeValue?.id === "ALL" ? {
            goalV: societes.reduce((n, m) => n + users.reduce((e, t) => e + (getGoalsFromDateProjUser(t.id, m.id, i + 1, yearValue)?.goalV || 0), 0), 0),
            goalE: societes.reduce((n, m) => n + users.reduce((e, t) => e + (getGoalsFromDateProjUser(t.id, m.id, i + 1, yearValue)?.goalE || 0), 0), 0),
            societesWithUsersWithNoGoal: societes.filter(n => users.find(e => !getGoalsFromDateProjUser(e.id, n.id, i + 1, yearValue))),
          } : {
            goalV: users.reduce((e, t) => e + (getGoalsFromDateProjUser(t.id, societeValue?.id, i + 1, yearValue)?.goalV || 0), 0),
            goalE: users.reduce((e, t) => e + (getGoalsFromDateProjUser(t.id, societeValue?.id, i + 1, yearValue)?.goalE || 0), 0),
            usersWithNoGoal: users.filter(e => !getGoalsFromDateProjUser(e.id, societeValue?.id, i + 1, yearValue)),
          }),
          month: i + 1,
          year: yearValue,
        })).reduce((e, t, i) => ({...e, [String(t.month)]: t}), {})
      },
      ...(showUsers && societeValue?.id !== "ALL" ? users.map(u => ({
        isUser: true,
        name: u.LOGIN,
        user: u,
        ...constants.DP_MONTHS.map((e, i) => ({
          ...getGoalsFromDateProjUser(u.id, societeValue?.id, i + 1, yearValue),
          month: i + 1,
          year: yearValue,
        })).reduce((e, t, i) => ({...e, [String(t.month)]: t}), {})
      })) : []),
    ])
  }, [budgets, goals, goal_societe_defaults, yearValue, users, showUsers])
  
  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
  }

  const filterOptions = (e, input) => {
    if(!e.value)
      return false;
    const filterWords = input.trim().split(' ');
    
    if(filterWords.length){
      let allWordsMatch = true;
      for(let word of filterWords){
        word = word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!e.value.LIBELE || !e.value.LIBELE.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(word))
          allWordsMatch = false
      }
      return allWordsMatch
    }
    
    return true;
  }

  return loadingB || loadingG || loadingGSD ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" md="6"><h2 className="title"><FontAwesomeIcon icon={faBullseye} />&nbsp;&nbsp;Tableau des objectifs</h2></Col>
          <Col sm="12" md="2" className="listPageFilterTitle">
            <Label for="societe">Projet : </Label>
          </Col>
          <Col sm="12" md="4" className="listPageFilterSelect">
            <Select
              name="reactselect"
              className="reactselect"
              classNamePrefix="react-select"
              id="societe"
              value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
              onChange={handleSocieteChange}
              placeholder={'Chercher par projet...'}
              isClearable={true}
              isLoading={loadingS}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              labelKey='LIBELE'
              // valueKey='code'
              options={societeOptions}
              filterOption={filterOptions}
            />
          </Col>
        </Row>
      </Container>
      <div className="fullFlexCenter">
        <div className="fullFlexCenter"><FontAwesomeIcon icon={faCaretLeft} className="goalCalendarYearCarets" onClick={() => setYearValue(e => Number(e) - 1)} title={`${Number(yearValue) - 1}`} /></div>
        <div className="goalCalendarYear">{yearValue}</div>
        <div className="fullFlexCenter"><FontAwesomeIcon icon={faCaretRight} className="goalCalendarYearCarets" onClick={() => setYearValue(e => Number(e) + 1)} title={`${Number(yearValue) + 1}`} /></div>
      </div>
      {!!societeValue ? usersLoading ? <Loading topSpace /> : <GoalTable linesData={tableData} societeValue={societeValue} goals={goals} goal_societe_defaults={goal_societe_defaults} budgets={budgets} setShowUsers={setShowUsers} showUsers={showUsers} /> : null}
    </>
  );
};

const mapStateToProps = (state: IGoalReduxProps0) => ({
  budget: state.budget,
  goal: state.goal,
  goal_societe_default: state.goal_societe_default,
  societe: state.societe,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getSocietes, getGoalsByProject, clearGoals, getGoal_societe_defaults, getBudgets })(GoalContainerComponent);
